module.exports = __webpack_public_path__ + "static/1319888855.876e0bb0.jpg";